/*
 * @Author: yexiu
 * @Date: 2024-04-08 10:26:45
 * @LastEditors: muqing
 * @LastEditTime: 2024-08-29 16:32:21
 */
import { ref, toRefs, computed } from 'vue';

export default (parameter: DevelopToolShare.InitParams) => ({
    name: "imageComponent",
    props: {
        n: {
            type: String,
            required: true,
            default: ''
        },
        t: {
            type: String,
            required: false,
            default: 'png'
        },
        v: {
            type: String,
            required: false,
            default: ''
        },
        // project 项目名
        p: {
            type: String,
            required: false,
            // 默认为 'public' 公共资源
            default: parameter.componentConfig?.image?.p ?? 'public'
        }
    },
    setup(props) {
        let { n, t, v, p } = toRefs<DevelopToolShare.TImageProps>(props);
        const domian = DOMAIN.H5_IMAGE_DOMAIN;
        let u = navigator.userAgent;
        // 判断是否是 android终端
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
        // 判断是否是 iOS终端
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // 图片是否是png结尾
        let refPng = ref<boolean>(['png', 'PNG'].includes(t.value));
        // 图片为png && 为安卓机型
        let copPhoneType = computed(() => refPng.value && isAndroid);
        // 图片src 后缀信息
        const copAfterInfo = computed(() => copPhoneType.value ? ('?x-oss-process=image/format,webp' + (v.value ? `&v=${v.value}` : '')) : v.value ? `?v=${v.value}` : '');
        // png apng 都取 png
        let copPng = computed(() => ['png', 'apng', 'PNG', 'APNG'].includes(t.value) ? 'png' : t.value);
        // 图片RSC
        const copSrc = computed(() => `${domian}/${p.value}/${n.value}.${copPng.value}${copAfterInfo.value}`);

        return () => (n.value && <img src={copSrc.value} />)
    }
});